// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeDeductionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/employee_deduction/{id}
 *
 * Returns a single employee deduction (one `employee_deductions` row) with its
 * enrichments and joined items. The dados is the flat deduction object — the
 * frontend reads `response.dados` directly as the deduction.
 *
 * Source: Employee_deductions_model::getWithItems() — SELECT ed.* plus the
 * computed `amount_remaining`, the `status_label`, and the joined `items[]`.
 * Mirrors the per-row shape declared on Payroll_DeductionRow (the list
 * endpoint's Row); kept as direct public properties here so the default
 * getDados() emits a concrete runtime schema for the single-object dados.
 *
 * Money columns (`amount`, `amount_paid`) are MySQL DECIMAL(10,2) and surface
 * as PHP strings via mysqli — typed `string` to match runtime.
 *
 * Datetimes (`created_at`, `updated_at`) are converted GMT-3 → ISO 8601 UTC
 * in the controller via convert_gmt3_to_utc_batch() before the Response is
 * built.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_EmployeeDeductionResponseDados {
id: number
employee_id: string
franchise_id: number
title: string
amount: string
status: number
amount_paid: string
created_at: string
created_by: string
description?: string
updated_at?: string
amount_remaining?: number
employee_name?: string
status_label?: string
items?: unknown[]
}

export type Payroll_EmployeeDeductionResponse = ApiResponse<Payroll_EmployeeDeductionResponseDados>;

registerResponseContract('Payroll_EmployeeDeductionResponse', {
  id:               { type: 'number',  required: true },
  employee_id:      { type: 'string',  required: true },
  franchise_id:     { type: 'number',  required: true },
  title:            { type: 'string',  required: true },
  amount:           { type: 'string',  required: true },
  status:           { type: 'number',  required: true },
  amount_paid:      { type: 'string',  required: true },
  created_at:       { type: 'string',  required: true },
  created_by:       { type: 'string',  required: true },
  description:      { type: 'string',  required: false },
  updated_at:       { type: 'string',  required: false },
  amount_remaining: { type: 'number',  required: false },
  employee_name:    { type: 'string',  required: false },
  status_label:     { type: 'string',  required: false },
  items:            { type: 'array',   required: false },
})
